import { useTheme } from "@web-src/themes/useTheme";
import { FC, ReactElement, useState } from "react";
import { Resizable } from "react-resizable";

interface ResizableSidebarWrapperProps {
  sidebarWidth: number;
  onWidthChange: (width: number) => void;
  children: (isResizing: boolean) => ReactElement<any>;
}

export const ResizableSidebarWrapper: FC<ResizableSidebarWrapperProps> = ({
  sidebarWidth,
  onWidthChange,
  children,
}) => {
  const { tcx } = useTheme();
  const [isResizing, setIsResizing] = useState(false);

  return (
    <Resizable
      width={sidebarWidth}
      axis="x"
      onResize={(_, data) => onWidthChange(data.size.width)}
      onResizeStart={() => setIsResizing(true)}
      onResizeStop={() => setIsResizing(false)}
      handle={
        <div
          className={tcx(
            "fixed top-[48px] z-[48] h-full w-1 cursor-ew-resize opacity-0 transition-opacity hover:opacity-100",
            {
              light: "bg-[#3690F2]",
              blue: "bg-[#103291]",
              dark: "bg-[#AFAFAF]",
            },
            isResizing && "opacity-100"
          )}
          style={{ left: `${sidebarWidth - 1}px` }}
        />
      }
      draggableOpts={{ enableUserSelectHack: false }}
    >
      {children(isResizing)}
    </Resizable>
  );
};
